<template>
  <div
    v-if="(replies && replies.length > 0) || replySize > 0"
    class="reply ht-night-exclude-child-nodes"
  >
    <div :class="boxEnterClass" class="box" :style="{ height: replyContent }">
      <div ref="innerBox" :class="innerBoxClass">
        <transition-group name="slide" appear :css="openReplyOnce">
          <ReplyItem
            v-for="(item, index) in replies.slice(0, renderingSize)"
            :key="item.id"
            class="slide-item"
            :comment-id="commentId"
            :comment-owner="commentOwner"
            :reply-index="index"
            :reply="item"
            @update:loaded-reply-size="setLoadedReplySize(loadedReplySize - 1)"
            @update:height="(args) => onChangeHeight(args, index)"
            @update:dis-height="(args) => onChangeDisHeight(args, index)"
          />
        </transition-group>
      </div>
    </div>
    <div
      v-if="replies.length === 0 && replySize > 1"
      class="init-load-more"
      @click.stop="loadMore($event)"
    >
      <span>展开 {{ replySize - renderingSize }} 条回复</span>
      <component :is="replyShowMoreIconName" class="reply-more-icon" />
    </div>
    <div v-if="replies.length > 0 && replySize > 1" class="reply-more" @click="loadMore($event)">
      <transition name="fade">
        <div v-if="isFoldedList" class="reply-more-title">
          <div v-if="isFoldedList && compareSize" class="reply-show-more">
            展开更多回复
          </div>
          <component
            :is="replyShowMoreIconName"
            v-if="isFoldedList && compareSize"
            class="reply-more-icon"
          />
          <div v-if="isFoldedList && replySize > 1" class="expand" @click.stop="foldList">
            <div class="reply-show-more">
              收起
            </div>
            <component :is="replyShowMoreIconName" class="fold-icon" />
          </div>
        </div>
        <div v-else class="reply-more-title">
          <div v-if="!isFoldedList && compareSize" class="reply-show-more fadeInContent">
            展开 {{ replySize - renderingSize }} 条回复
          </div>
          <component
            :is="replyShowMoreIconName"
            v-if="!isFoldedList && compareSize"
            class="reply-more-icon"
          />
        </div>
      </transition>
    </div>
    <!-- <div v-else-if="loadStatus == LoadStatus.LOADING" class="reply-more">
      <span>正在加载回复</span>
    </div> -->

    <div v-if="loadStatus == LoadStatus.LOADERROR" class="reply-more" @click.stop="loadMore">
      <span>加载失败，点击重试</span>
    </div>

    <!-- 添加网络异常地请情况 -->
    <div
      v-else-if="loadStatus == LoadStatus.POOR_NETWORK"
      class="reply-more"
      @click.stop="loadMore"
    >
      <span>网络链接失败</span>
    </div>

    <div
      v-else-if="loadStatus == LoadStatus.NO_CONNECTION"
      class="reply-more"
      @click.stop="loadMore"
    >
      <span>网络服务已断开</span>
    </div>

    <div v-else-if="loadStatus == LoadStatus.NO_SERVICE" class="reply-more" @click.stop="loadMore">
      <span>网络服端错误</span>
    </div>
  </div>
</template>

<script lang="ts">
import { toRefs, ref, watchEffect, onMounted, defineComponent, computed, nextTick, reactive } from 'vue';
import { useReplyList, useGlobalState } from '@cpc/comment-sdk-core-comment';
import { constant, utils, eventBus } from '@cpc/comment-sdk-common';

import ReplyItem from './ReplyItem.vue';
import ReplyShowMore from './ReplyShowMoreIcon/ReplyShowMore.vue';
import ReplyShowMoreDark from './ReplyShowMoreIcon/ReplyShowMoreDark.vue';

export default defineComponent({
  name: 'ReplyList',

  components: {
    ReplyItem,
    ReplyShowMore,
    ReplyShowMoreDark,
  },

  props: {
    commentId: {
      type: String,
      required: true,
      default: '',
    },

    replies: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },

    replySize: {
      type: Number,
      required: true,
      default: 0,
    },

    commentOwner: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  setup(props) {
    const { query, $ } = utils;
    // 获取回复数高度
    const innerBox = ref(null);
    // 回复高度
    const replyContent = ref(null);
    // 是否有动画
    const isAnimation = ref(false);
    const { LoadStatus } = constant;

    const { commentId, replies, replySize } = toRefs(props);
    const {
      loadStatus,
      fetchMoreReplies,
      loadedReplySize,
      setLoadedReplySize,
      enableUsePreloadList,
    } = useReplyList({
      commentId,
      replies,
      replySize,
    });

    const { feature, isNightMode } = toRefs(useGlobalState());

    const enableSecondtDetail = feature.value.enableSecondCommentDetail;
    const renderingSize = ref(feature.value.replyDefaultDisplaySize);

    const openReplyOnce = ref(false);
    const isFoldedList = ref(false);

    const replyShowMoreIconName = computed(() => {
      return isNightMode.value ? 'ReplyShowMoreDark' : 'ReplyShowMore';
    });

    const loadMore = (event) => {
      event && event.stopPropagation();
      isFoldedList.value = true;
      renderingSize.value = renderingSize.value + 10;
      isAnimation.value = true;

      if (!openReplyOnce.value) {
        openReplyOnce.value = true;
      }

      if (
        renderingSize.value <= replies.value.length
        || loadStatus.value === LoadStatus.LOADCOMPLETED
      ) {
        nextTick(() => {
          replyContent.value = `${innerBox.value.offsetHeight}px`;
        });

        return;
      }

      fetchMoreReplies().then(() => {
        setTimeout(() => {
          nextTick(() => {
            replyContent.value = `${innerBox.value.offsetHeight}px`;
          });
        });
      });
    };

    const foldList = () => {
      isFoldedList.value = !isFoldedList.value;
      renderingSize.value = feature.value.replyDefaultDisplaySize;
      setTimeout(() => {
        replyContent.value = `${innerBox.value.offsetHeight}px`;
      }, 300);
      isAnimation.value = true;
    };

    const compareSize = computed(() => {
      return replySize.value > renderingSize.value;
    });

    const boxEnterClass = computed(() => {
      return isAnimation.value ? 'box-enter' : '';
    });

    const innerBoxClass = computed(() => {
      return isAnimation.value ? 'inner-ox' : '';
    });

    watchEffect(() => {
      switch (loadStatus.value) {
        case LoadStatus.POOR_NETWORK:
          // showToast('服务器异常,请稍后再试!');
          break;

        case LoadStatus.NO_CONNECTION:
          // showToast('无网络链接,请设置网络');
          break;

        case LoadStatus.NO_SERVICE:
          // showToast('网络信号差,请稍后重试');
          break;

        case LoadStatus.LOADERROR:
          // showToast('请求失败,请稍后重试');
          break;

        default:
          break;
      }
    });

    eventBus.on('ANIMATION_CONTROL', (isSend: boolean) => {
      if (!isSend) {
        isAnimation.value = false;
        replyContent.value = '100%';
      }
    });

    const replylistHeightArr = ref([]);
    const replylistHeight = ref(0);

    const calcReplylistHeight = () => {
      return replylistHeightArr.value.slice(0, renderingSize.value).reduce((sums, item) => {
        return sums + item.height + (item.disHeight || 0);
      }, 0);
    };

    onMounted(() => {
      fetchMoreReplies().then(() => {
        nextTick(() => {
          replyContent.value = `${innerBox.value?.offsetHeight}px`;

          replylistHeight.value = calcReplylistHeight();
        });
      });

      enableUsePreloadList();
    });

    const onChangeHeight = (height: number, index: number) => {
      if (!replylistHeightArr.value[index]) {
        replylistHeightArr.value[index] = {
          height,
          disHeight: 0,
        }
      } else {
        replylistHeightArr.value[index].height = height;
      }
      if (height === 0) {
        replylistHeightArr.value[index].disHeight = 0;
      }
    }

    const onChangeDisHeight = (_disHeight: number, index: number) => {
      // 展示过渡动画
      nextTick(() => {
        replyContent.value = `${replylistHeight.value}px`;
        isAnimation.value = true;

        setTimeout(() => {
          replylistHeightArr.value[index].disHeight += _disHeight;
          replylistHeight.value = calcReplylistHeight();

          replyContent.value = `${replylistHeight.value}px`;
        }, 0);
      })
    }

    return {
      LoadStatus,
      loadStatus,
      replyShowMoreIconName,
      loadMore,
      openReplyOnce,
      enableSecondtDetail,
      renderingSize,
      foldList,
      isFoldedList,

      compareSize,
      innerBox,
      replyContent,
      boxEnterClass,
      innerBoxClass,

      loadedReplySize,
      setLoadedReplySize,

      onChangeHeight,
      onChangeDisHeight,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '../assets/css/styling-mixin.scss';
.reply {
  position: relative;
}
.slide-item {
  transition: opacity 0.2s cubic-bezier(0.17, 0.17, 0.83, 0.83);
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0 !important;
}

.reply-more-title {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s cubic-bezier(0.17, 0.17, 0.83, 0.83);
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.reply-more-icon {
  margin: 0 60px 0 18px;
}

.init-load-more {
  font-size: 36px;
  font-family: ColorFont-Regular, 'OPlusSans 3.0';
  text-align: left;
  line-height: 60px;
  margin-left: 186px;
  color: rgba($color: #000, $alpha: 1);
}

.reply-more {
  font-size: 36px;
  font-family: ColorFont-Regular, 'OPlusSans 3.0';
  text-align: left;
  line-height: 48px;
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
  margin: 24px 0 12px 282px;
  position: relative;
  padding-bottom: 48px;
  &:empty {
    margin-bottom: 0;
    margin-left: 0;
  }
  @include os-browser-styling('', '', false, false, true, true) {
    color: rgba($color: #fff, $alpha: 1);
  }
}

.reply-show-more {
  display: flex;
  align-items: center;
  color: rgba($color: #000, $alpha: 0.9);
}

.reply-show-more-icon {
  width: 16px;
  height: 28px;
  margin-left: 21px;
  padding-bottom: 3px;
}

.expand {
  display: flex;
  align-items: center;
}

.fold-icon {
  transform: rotate(180deg);
  margin-left: 12px;
}

.box {
  position: relative;
  overflow: hidden;
}
.inner-box {
  position: absolute;
  width: 100%;
}
.box-enter {
  transition: height 0.4s cubic-bezier(0.3, 0, 0.1, 1);
}

html[data-theme='dark'] {
  // .reply {
  //   background-color: #f5f5f5;
  // }
  .reply::before {
    content: '';
    display: none;
  }

  .reply-show-more {
    color: rgba($color: #fff, $alpha: 0.9);
  }
}
</style>
